<template>
  <div class="new-password-form" layout layout-align="center-center">
    <form @submit.prevent="submit($v)">
      <el-card>
        <div class="el-card-header">
          <div class="logo"><img src="@/client/assets/images/atelu_logo.svg" /></div>
        </div>
        <div class="mt-x2">
          <div class="message message-info">新しいパスワードを入力してください。</div>
          <div class="input-container">
            <el-input
              :class="{ success: $v.password.required && !$v.password.$invalid }"
              placeholder="パスワード"
              :maxlength="100"
              type="password"
              v-model="password"
              @blur="$v.password.$touch"
              tabindex="1"
            >
              <template slot="prepend"><i class="mdi mdi-key-variant"></i></template>
            </el-input>
            <div class="invalid" v-if="!$v.password.required && $v.password.$error">パスワードを入力してください。</div>
            <div class="input-invalid-text" v-if="!$v.password.minLength && $v.password.$error">
              パスワードは8文字以上にしてください。
            </div>
          </div>
        </div>
        <div class="el-card-action">
          <el-button class="mb-x2" type="primary" native-type="submit" :disabled="$v.$invalid === true"
            ><i class="mdi mdi-save"></i>パスワード再設定</el-button
          >
        </div>
      </el-card>
    </form>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.new-password-form {
  height: 100%;
}

form {
  width: 100%;
  max-width: $spacing-unit * 62;
}

.el-card {
  width: 100%;
  padding: $spacing-unit * 2;
}

.el-card-header {
  padding: $spacing-unit * 3;

  .logo {
    text-align: center;
  }
}

.el-card-action {
  display: block;
  margin: $spacing-unit * 6 0 $spacing-unit * 2 0;

  button {
    width: 100%;
  }

  .el-button + .el-button {
    margin-left: 0;
  }
}

.input-container {
  width: 100%;
  margin: $spacing-unit * 3 0 0;

  .invalid {
    display: block;
    margin-top: $spacing-unit;
    font-size: $font-small-size;
    color: $danger-color;
  }
}

.small {
  margin-top: $spacing-unit;
}

.message {
  padding: $spacing-unit;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue'
import { minLength, required } from 'vuelidate/lib/validators'

import api from '@/client/core/api'

export default defineComponent({
  props: {
    code: String
  },
  data() {
    return {
      password: ''
    }
  },
  created() {
    // パスワードリクエストコードをチェック
    this.checkRequestPasswordCode()
  },
  methods: {
    /**
     * ログインサブミット
     * @return {void}
     */
    submit: async function ($v: any) {
      // validations
      $v.$touch()
      if ($v.$invalid === true) {
        return
      }

      const params = {
        code: this.code,
        password: this.password
      }
      const result = await api.post('/users/password_resets', params)
      // エラーがある場合は表示
      if (result.error && result.error.type === 'NOT_EXISTS') {
        this.$notify({
          title: 'パスワードの再設定に失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 10000
        })
        this.$router.push('/login')
        return
      }
      if (result.data !== true) {
        this.$notify({
          title: 'パスワードの再設定に失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 10000
        })
        return
      }

      // 成功する場合
      this.$notify({
        title: 'パスワードを再設定しました。',
        message: '',
        customClass: 'success',
        duration: 10000
      })
      this.$router.push('/login')
    },

    /**
     * パスワードリクエストコードをチェック
     */
    async checkRequestPasswordCode() {
      const result = await api.get('/users/new_password_requests', {
        params: {
          code: this.code
        }
      })
      // 存在しない場合
      if (result.error && result.error.type === 'NOT_EXISTS') {
        this.$notify({
          title: 'パスワード再設定URLが無効です。',
          message: '',
          customClass: 'danger',
          duration: 10000
        })
        this.$router.push('/login')
        return
      }

      // 有効期限が切れている場合
      if (result.error && result.error.type === 'CODE_EXPIRED') {
        this.$notify({
          title: 'パスワードリセットの有効期限が切れています。',
          message: '恐れ入りますが、再度パスワードリセットをお試しください。',
          customClass: 'danger',
          duration: 10000
        })
        this.$router.push('/login')
        return
      }

      // エラーがある場合
      if (!result.data || !result.data.userId) {
        this.$notify({
          title: 'エラーが発生しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 10000
        })
        this.$router.push('/login')
      }
    }
  },
  validations: {
    password: {
      required,
      // パスワードは8文字以上が必要
      minLength: minLength(8)
    }
  }
})
</script>
